import { api } from "@/api/client";
import { EMISSION_BASE } from "@/api/config";

export type ImportFileStatus =
  "YetToStart" | "Queued" | "InProgress" | "Completed" | "Error" | "Warn";

export interface ImportFile {
  id: number;
  original_name: string;
  status: ImportFileStatus;
  size: number;
  attempted_count?: number;
  succeeded_count?: number;
  failed_count?: number;
  attemptedCount?: number;
  succeededCount?: number;
  failedCount?: number;
  created: string;
  errors?: Record<string, string>;
  category?: number | null;
  asset_based?: boolean;
  category_name?: string | null;
  category_code?: string | null;
  emission_method?: number | null;
  method_name?: string | null;
  emission_type_name?: string | null;
  emission_sub_type_name?: string | null;
}

export interface ImportFileListResponse {
  files: ImportFile[];
  total_count: number;
}

interface RegisterImportFilePayload {
  assetBased?: boolean;
  originalName: string;
  fileName: string;
  filePath: string;
  company: string;
  typeName: string;
  ownerName: string;
  businessUnit?: string;
  emissionType?: number;
  emissionSubType?: number;
  emissionMethod?: number;
  category?: number;
}

/**
 * Shared CRUD for `/emission/v1/importfile(s)` + `/samplefile`, used by both the
 * emission bulk-upload and supplier bulk-upload flows. Callers are
 * differentiated by `typeName`.
 */
export async function registerImportFile(
  payload: RegisterImportFilePayload,
): Promise<{ id: number }> {
  return api("post", `${EMISSION_BASE}/importfile`, payload);
}

export async function getImportFiles(
  page: number,
  limit: number,
  typeName: string,
  extraParams?: Record<string, string | number>,
): Promise<ImportFileListResponse> {
  return api("get", `${EMISSION_BASE}/importfiles`, undefined, {
    page: page + 1,
    limit,
    type_name: typeName,
    ...extraParams,
  });
}

export async function getImportFileStatus(id: number): Promise<ImportFile> {
  return api("get", `${EMISSION_BASE}/importfile`, undefined, { id });
}

export async function removeImportFile(
  id: number,
): Promise<{ success: boolean }> {
  return api("put", `${EMISSION_BASE}/importfile`, {
    id,
    isDelete: true,
  });
}

export async function getSampleFile(
  typeName: string,
  extra?: Record<string, string | number>,
): Promise<{ filePath: string }> {
  return api("get", `${EMISSION_BASE}/samplefile`, undefined, {
    type_name: typeName,
    ...extra,
  });
}
